module.exports = __webpack_public_path__ + "images/df6bb3003c63d439adfbc2a194320640.png";